export default "__VITE_ASSET__Bzz4NMR$__"